(function($, window, document, undefined) {
  var $win = $(window);
  var $doc = $(document);
  var product = window.product;
  var $product;

  $doc.ready(function() {
    $product = $('#product');

    // Label focus move
    $('.field, .textarea').on('keydown keyup', function() {
      var $field = $(this),
          $parent = $field.parent(),
          $label = $field.prev('label');

      if ($label.length) {
        $parent.toggleClass('form-show-label', Boolean($field.val().length) );
      };

    }).each(function() {
      var $field = $(this),
          $parent = $field.parent(),
          $label = $field.prev('label');

      if ($label.length) {
        $parent.toggleClass('form-show-label', Boolean($field.val().length) );
      };

    });

    // Mobile Menu

    $('.btn-menu').on('click', function (event) {
      $(this).toggleClass('active').closest('body').toggleClass('header-visible');
      event.preventDefault();
    });

    // Product Slider
    


    $('.addresses .cancel').on('click', function(event) {
      var $section = $(this).closest('.accordion-section');

      $section.find('.accordion-body').slideUp();

      event.preventDefault();
    });

    $('.btn-new-adress, .form-add-address .cancel').on('click', function(event) {

      $('.form-add-address').slideToggle();

      event.preventDefault();
    });

    // Variants listing logic - [Radio/Select]
    
    var $select = $('#product-select');
    if ($select.length) {
      $('.radio-variants input').on('change', function() {
        var productPriceHolder = $('.product-price');
        var dataSelector = ''
        $(this).closest('.radio-variants').find('input:checked').each(function() {
          var $this = $(this);
          dataSelector += '[data-'+ $this.data('type') +'="' +  $this.val() + '"]';
        })
        if ($(dataSelector).length && $(dataSelector).attr('disabled') != 'disabled' ) {
          productPriceHolder.text($(dataSelector).data('price'));

          $('.addtocart').prop('disabled', false)
        
        }else{
          $('.addtocart').prop('disabled', true)
                   
          productPriceHolder.text('Sold Out');
        }
        $select.val($(dataSelector).val());   
      })
      $select.hide();
    };

    

  });

  Shopify.CustomerAddress = {
    toggleForm: function(address_id) {
      var $form = $('#address_form_' + address_id),
          $section = $form.closest('.accordion-section');

      $section.find('.accordion-body').stop().slideToggle();

      $section.siblings().find('.accordion-body').stop(true, true).slideUp();

      return false;
    },

    destroy: function(id, confirm_msg) {
      if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
          Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
    }
  }
}
  })(jQuery, window, document);

function cart_slider(){
//   $('.cart__foot-inner .list-simple-products').slick({
//     arrows: true,
//     dots: false,
//     autoplay: true,
//     infinite: true,
//     slidesToShow: 2,
//     autoplaySpeed: 5000,
//     slidesToScroll: 1,
//     centerMode: true,
//     prevArrow: '<button type="button" class="slick-prev"><img src="//www.hyperlitemountaingear.com/cdn/shop/t/466/assets/slider-arrow-left.png?v=77436670470641791341724965621"></button>',
//     nextArrow: '<button type="button" class="slick-next"><img src="//www.hyperlitemountaingear.com/cdn/shop/t/466/assets/slider-arrow-right.png?v=94229128798139122941724965621"></button>',
//     responsive: [
//       {
//         breakpoint: 530,
//         settings: {
//           slidesToShow: 1,
//         }
//       }
//     ]
//   });
}

$( document ).ready(function() {
var swiper = new Swiper(".cart-swiper", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
          speed: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          530: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 1,
          },
        },
      });

//   $('.js-slider-images-alt').slick({
//     arrows: true,
//     dots: true,
//     infinite: true
//   });
  var $navTags = $('.nav-tags');
  if ($navTags.length) {
    var navTagsLiLength = $navTags.find('li').length;
    var addAdditionalClass = navTagsLiLength % 2;
    if (addAdditionalClass == 0 && navTagsLiLength !== 6) {
      $navTags.addClass('nav-tags--alt');
    }
  }

  $('.animation').addClass('animation-done');

});

$(window).on('load resize orientationchange', function() {
  cart_slider();
});

$(window).on('load',function(){
  $('.animation-high').addClass('animation-done');  
});

$( document ).ready(function() {
  
  // var sliderWrapper = $('.sliders').not('.section-product .sliders.gallery');
  
  var mySwiper1 = new Swiper('.section-product .sliders.default_slider', {
    direction: 'horizontal',
    autoplay: false,
    cache: false,
    loop: true,
    allowTouchMove: true,
    preloadImages: true,
    lazy: false,
    lazy: {
      loadOnTransitionStart: true,
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    //    autoplay: {
    //      delay: 5000,
    //    },
    on: {
      init: function () {
//         $('.section-product .slider').css('opacity','1');
      },
      slideChange: function(){
        setTimeout(function(){
          if($('.media-video').length){
            if($('.swiper-slide-active').find('.product-single__media--video').length){
              $('.media-video').trigger('play'); 
            }
            else{
              $('.media-video').trigger('pause'); 
            }
          }
        },50);
      },
      touchEnd: function(){
        setTimeout(function(){
          if($('.media-video').length){
            if($('.swiper-slide-active').find('.product-single__media--video').length){
              $('.swiper-slide-active').find('.product-single__media--video').find('.media-video').trigger('play'); 
            }
            else{
              $('.media-video').trigger('pause'); 
            }
          }
        },50);

      }
    }
  });

var Thumbswiper = null;
/*function initSwiper() {
  let swiperOptions = {
    loop: false,
    spaceBetween: 12,
    slidesPerView: 3,
    slidesOffsetAfter: 32,
    slidesOffsetBefore: 32,
    freeMode: false,
    // simulateTouch: false,
    cssMode: false,
    effect: "slide",
    touchStartPreventDefault: false,
    updateOnWindowResize: true,
    allowTouchMove: false,
    touchMoveStopPropagation: false,
    direction: 'horizontal',
    observer: false,
    resizeObserver:true,
    slideToClickedSlide: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      375: {
        slidesPerView: 4
      },
      1200: {
        slidesPerView: 5
      },
      1441: {
        slidesPerView: 5,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
        direction: 'vertical'
      }
    },
    on: {
      init: function() {
              checkArrow();
      },
      resize: function () {
        console.log("resize")
          checkArrow();
        if(window.outerWidth >= 1441){
          swiperOptions.direction =  "vertical";    
        }else{
          swiperOptions.direction =  "horizontal";
        }
        console.log(swiperOptions.direction);
        // Thumbswiper.destroy(false,true);
        // setTimeout(function(){
        //   Thumbswiper.init(swiperOptions);
        // },200)
      }
    }
  }
  Thumbswiper = new Swiper('.section-product .sliders.thumbs', swiperOptions);
  function checkArrow() {
      var swiperPrev = document.querySelector('.swiper-button-prev');
      var swiperNext = document.querySelector('.swiper-button-next');
      if ( window.innerWidth > 1440 && document.querySelectorAll('.thumbs .swiper-slide').length == 5 ) {
        // console.log('Success', window.innerWidth);
        swiperPrev.style.display = 'none';
        swiperNext.style.display = 'none';
      } 
   }

}*/




/* 
--------------------------------------------
temporary Working code Start
--------------------------------------------
*/





  
  /*let thumbselemets = document.querySelectorAll('.thumbs .swiper-slide'),
    thumbs = null,
    swiperOptions = {};
  if(thumbselemets.length > 1 ){
    swiperOptions = {
      loop: false,
      spaceBetween: 12,
      slidesPerView: 1,
      // slidesOffsetAfter: 32,
      // slidesOffsetBefore: 32,
      freeMode: false,
      // simulateTouch: false,
      draggable:true,
      cssMode: false,
      effect: "slide",
      // touchStartPreventDefault: false,
      updateOnWindowResize: true,
      resizeObserver:true,
      allowTouchMove: true,
      // touchMoveStopPropagation: false,
      direction: 'horizontal',
     
      // observer: true,
      slideToClickedSlide: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        320: {
          slidesPerView: 4,
          slidesOffsetAfter: 32,
          slidesOffsetBefore: 32
        },
        1200: {
          slidesPerView: 5,
          slidesOffsetAfter: 32,
          slidesOffsetBefore: 32
        },
        1441: {
          slidesPerView: 5,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          direction: 'vertical'
        }
      }
    }
    if(thumbselemets.length < 5){
      swiperOptions.loop = false;
      swiperOptions.spaceBetween = 12;
      swiperOptions.slidesPerView = 4;
      swiperOptions.freeMode = false;
      swiperOptions.shortSwipes = false;
      swiperOptions.preventClicksPropagation = false;
      swiperOptions.preventClicks = false;
      swiperOptions.allowTouchMove = false;
      swiperOptions.direction = 'horizontal';
      swiperOptions.breakpoints = {
        
        360: {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          direction: 'horizontal',
          slidesPerView: 3,
          slidesOffsetAfter: 12,
          slidesOffsetAfter: 32,
          slidesOffsetBefore: 32
        },
        1200: {
          slidesPerView: 5
        },
        1441: {
          direction: 'vertical'
        }
      };
      swiperOptions.cssMode = false;
    }

    thumbs = new Swiper ('.section-product .sliders.thumbs',swiperOptions);

    thumbs.on('init', function () {
      checkArrow();
    });

    function checkArrow() {
      var swiperPrev = document.querySelector('.swiper-button-prev');
      var swiperNext = document.querySelector('.swiper-button-next');
      // swiperPrev.style.display = 'none';
      // swiperNext.style.display = 'none';
      if ( window.innerWidth > 1440 && $('.thumbs .swiper-slide').length == 5 ) {
      } 
   }
  }


  function videoAction(element,play){
    let videoElement = element.querySelector('video.media-video');
    if(!videoElement) return;
    if(videoElement.paused == true) videoElement.play();
    if(play == false) videoElement.pause();
  }
  
console.log(thumbs);

  let swiper2options = {
    direction: 'horizontal',
    loop: false,
    preloadImages: true,
    // updateOnWindowResize: true,
    // lazy: {
    //   loadOnTransitionStart: true,
    //   loadPrevNext: true,
    //   loadPrevNextAmount: 2
    // }
    };
  if(thumbs){
    swiper2options.thumbs = {
      swiper: thumbs
    }
  }
      
  var swiper2 = new Swiper('.section-product .sliders.gallery', swiper2options);

    swiper2.on('slideChangeTransitionEnd', function (element) {
      videoAction(element.slides[element.activeIndex],true);
    });
    swiper2.on('sliderFirstMove', function (swiper, event) {
      videoAction(swiper.slides[swiper.activeIndex],false)
    });
    swiper2.on('slideResetTransitionEnd', function (swiper) {
      videoAction(swiper.slides[swiper.activeIndex],true)
    });

   window.addEventListener('resize', function () {
      if(window.outerWidth >= 1441){
        swiperOptions.direction = 'vertical';  
        thumbs.changeDirection('vertical',true);
      }
      if(window.outerWidth < 1441){
        swiperOptions.direction =  'horizontal' ;
        thumbs.changeDirection('horizontal',true);
      }
       thumbs.destroy(false,true);
       thumbs = new Swiper ('.section-product .sliders.thumbs',swiperOptions);
       swiper2.destroy(false,true);
       swiper2options.thumbs = {
          swiper: thumbs
        }
       swiper2 =  new Swiper('.section-product .sliders.gallery', swiper2options);
    });*/


/* 
--------------------------------------------
temporary Working code End
--------------------------------------------
*/

  
  
/* 
--------------------------------------------
New Product Slider Code Start
--------------------------------------------
*/

  let mainProductSlider = document.querySelector('.js-main-product-image-swiper'),
      minProductThumbSlider = document.querySelector('.js-main-product-image-thumbnail-swiper');

  function showHideArrows(swiper){
    if(swiper.slides.length <= swiper.params.slidesPerView){
      swiper.navigation.nextEl[0].classList.add('hidden');
      swiper.navigation.prevEl[0].classList.add('hidden');
      swiper.allowTouchMove = false;
    }else{
      swiper.navigation.nextEl[0].classList.remove('hidden');
      swiper.navigation.prevEl[0].classList.remove('hidden');
      swiper.allowTouchMove = true;
    }
  }
  
  let minProductThumbSlider_swiper = new Swiper(minProductThumbSlider,{
    draggable:true,
    watchSlidesProgress:true,
    direction:'horizontal',
    spaceBetween: 12,
    slidesPerView: 2,
    autoHeight:true,
    updateOnWindowResize: true,
    slideToClickedSlide:true,
    resizeObserver:true,
    slidesPerGroup:1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    
    breakpoints:{
      320: {
        slidesPerView: 3,
        slidesOffsetAfter: 31,
        slidesOffsetBefore: 31
      },
      425: {
        slidesPerView: 3.5,
        direction:'horizontal',
        slidesOffsetAfter: 31,
        slidesOffsetBefore: 31
      },
      1441:{
        slidesPerView: 5,
        direction:'vertical',
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0
      }
    },
     on: {
      init: function (swiper) {
        console.log(swiper);
        showHideArrows(swiper);
      },
      resize: function (swiper) {
        showHideArrows(swiper);
      },
    }
  })
  
  let mainProductSlider_swiper = new Swiper(mainProductSlider, {
    draggable:true,
    cssMode: false,
    slidesPerView:1,
    slidesPerGroup:1,
    lazyPreloadPrevNext:1,
    preloadImages: true,
    updateOnWindowResize: true,
    slideToClickedSlide:true,
    resizeObserver:true,
    thumbs: {
      swiper: minProductThumbSlider_swiper
    }
  });

/* 
--------------------------------------------
New Product Slider Code End
--------------------------------------------
*/







  
  
  //  if($('.thumbs .swiper-slide').length <= 3 ){
    
  //   $('.thumbs .swiper-slide').click(function(){
  //     $('.thumbs .swiper-slide').removeClass('active');
      
  //     swiper2.slideTo($(this).index());
  //       swiper2.update(true);
  //     $(this).addClass('active');
  //     console.log('this',$(this).index());
  //   })
  // }
  
  
  /*if(document.querySelectorAll('.thumbs .swiper-slide').length > 3 ){
      if($('.thumbs .swiper-slide').length >= 5 ){
      var thumbs = new Swiper ('.section-product .sliders.thumbs', {
          loop: false,
          spaceBetween: 12,
          slidesPerView: 1,
          slidesOffsetAfter: 32,
          slidesOffsetBefore: 32,
          freeMode: false,
        // simulateTouch: false,
        cssMode: false,
        effect: "slide",
        touchStartPreventDefault: false,
        updateOnWindowResize: false,
        allowTouchMove: true,
        touchMoveStopPropagation: false,
        direction: 'horizontal',
        // observer: true,
        slideToClickedSlide: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
            375: {
              slidesPerView: 4
            },
            1200: {
              slidesPerView: 5
            },
            1441: {
              slidesPerView: 5,
              slidesOffsetAfter: 0,
              slidesOffsetBefore: 0,
              direction: 'vertical'
            }
          },
          on: {
          init: function() {
            checkArrow();
          },
          resize: function () {
            console.log('ssssss')
          checkArrow();
            if(window.outerWidth >= 1441){
              thumbs.changeDirection('vertical',true);
            }else{
              thumbs.changeDirection('horizontal',true);
            }
          }
        }
      });
      function checkArrow() {
        var swiperPrev = document.querySelector('.swiper-button-prev');
        var swiperNext = document.querySelector('.swiper-button-next');
        if ( window.innerWidth > 1440 && $('.thumbs .swiper-slide').length == 5 ) {
          console.log('Success', window.innerWidth);
          swiperPrev.style.display = 'none';
          swiperNext.style.display = 'none';
        } 
     }
    }else{
      var thumbs = new Swiper ('.section-product .sliders.thumbs', {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 4,
        freeMode: false,
        // slidesPerView: 'auto',
        shortSwipes: false,
        preventClicksPropagation: false,
          // updateOnWindowResize: true,
        preventClicks: false,
        allowTouchMove: false,
        direction: 'horizontal',
        breakpoints: {
          360: {
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            direction: 'horizontal',
            slidesPerView: 3,
            slidesOffsetAfter: 12,
          },
          1200: {
            slidesPerView: 5
          },
          1441: {
            direction: 'vertical'
          }
        },
  //    simulateTouch: false,
        cssMode: false,
        on: {
          init: function() {
            checkArrow();
          },
          resize: function () {
            checkArrow();
          }
        }
      });
      function checkArrow() {
        var swiperPrev = document.querySelector('.swiper-button-prev');
        var swiperNext = document.querySelector('.swiper-button-next');
        swiperPrev.style.display = 'none';
        swiperNext.style.display = 'none';
      }
  
    }
  }*/


    /*navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
    ,
    autoplay: {
      delay: 5000,
    },*/


// initSwiper();
// window.addEventListener('resize', function () {
//  setTimeout(function(){
//   initSwiper();
//  },300);
//   // timer = setTimeout(initSwiper, 200);
// });



  /*var swiper2 = new Swiper('.section-product .sliders.gallery', {
        // spaceBetween: 10,
        thumbs: {
          swiper: thumbs
        },
    direction: 'horizontal',
//     autoplay: false,
//     cache: false,
    loop: true,
    preloadImages: true,
    lazy: false,
    lazy: {
      loadOnTransitionStart: true,
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },
//     thumbs: {
//       swiper: thumbs
//     },
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
    //    autoplay: {
    //      delay: 5000,
    //    },
//     on: {
//       init: function () {
// //         $('.section-product .slider').css('opacity','1');
//       },
//       slideChange: function(){
//         setTimeout(function(){
//           if($('.media-video').length){
//             if($('.swiper-slide-active').find('.product-single__media--video').length){
//               $('.media-video').trigger('play'); 
//             }
//             else{
//               $('.media-video').trigger('pause'); 
//             }
//           }
//         },50);
//       },
//       touchEnd: function(){
//         setTimeout(function(){
//           if($('.media-video').length){
//             if($('.swiper-slide-active').find('.product-single__media--video').length){
//               $('.swiper-slide-active').find('.product-single__media--video').find('.media-video').trigger('play'); 
//             }
//             else{
//               $('.media-video').trigger('pause'); 
//             }
//           }
//         },50);

//       }
//     },
    });*/
  
//   $('.section-product .sliders.thumbs')
//   .on('click', '.swiper-button-prev', function() {
//     thumbs.slidePrev();
//   })
//   .on('click', '.swiper-button-next', function() {
//     thumbs.slideNext();
//   }); 
  
  //   mySwiper.navigation.update();

  $('.list-radios input').on('click change', function() {
    $('.startingat').hide();
    var cc = $(this).closest('#AddToCartForm').find('.swatch-wrapper').length;
    var iid = $('#product-select').children("option:selected").data('iid');
    var pvd = $( "#product-select option:selected" ).val();
    var url = new URL(location.href);
    var sku = $('#product-select').children("option:selected").data('sku');
    $(".variant_sku").removeClass('sku-hide');
    $(".variant_sku .sku").html("SKU: "+sku);
    url.searchParams.set('variant', pvd);
    history.pushState({}, null, url);
    
    
    var check = true;
    $(this).closest('#AddToCartForm').find('.swatch-wrapper').find("input:radio").each(function(){
      var name = $(this).attr("name");
      if($('input:radio[name="'+name+'"]:checked').length == 0){
        check = false;
      }
    });

    if(check){
      $('.shipping_notice_class').hide();
      $('.shipping_notice_default_class').hide();
      var pvd = $( "#product-select option:selected" ).val();
      var va = $( "#product-select option:selected" ).attr('data-va');
     
      $(".shipping_notice_class[data-id='" + pvd + "']").show(); 
      if(va == "false")
      {
        $(".shipping_notice_class[data-variants-a='" + va + "']").hide();
      }
      //$(".shipping_notice_class[data-variants-a='" + va + "']").show(); 
      
      
      $(".shipping_notice_default_class[data-variants-av='" + va + "']").show();
      if(iid == undefined){
        $(this).closest('#AddToCartForm').find('#addtocartbtn').val('Unavailable');
        $(this).closest('#AddToCartForm').find('#addtocartbtn').prop('disabled', true);
      }
    } else {
//       alert('Please select one option in each question.');
    }
    
    
    
//     $(this).closest('#AddToCartForm').find('.swatch-wrapper').each(function(e){
//       var th = $(this);
//       if(th.find(':radio:checked').length > 0 && iid == undefined ) {
//         $(this).closest('#AddToCartForm').find('#addtocartbtn').val('Unavailable');
//         $(this).closest('#AddToCartForm').find('#addtocartbtn').prop('disabled', true);
//       }
//       else{
//         //         $(this).closest('#AddToCartForm').find('#addtocartbtn').val('Add to cart');
//         //         $(this).closest('#AddToCartForm').find('#addtocartbtn').prop('disabled', false);
//       }
//     }); 


    // console.log('iid',iid);
      if(iid != undefined && iid != ""){
        var nid = $.trim(iid);
        var ind = $('.sliders').find('.swiper-slide').find('img[data-id="'+nid+'"]').closest('.swiper-slide:not(.swiper-slide-duplicate)').index();
        var ind2 = $.trim(ind);
      //  console.log('ind2',ind2);
      //  console.log(nid,ind,$('.sliders').find('.swiper-slide').find('img[data-id="'+nid+'"]').closest('.swiper-slide:not(.swiper-slide-duplicate)'));
        mainProductSlider_swiper.slideTo(ind2);
        mainProductSlider_swiper.update(true);
      }
  });

  var blogSwiper = new Swiper('.slider-intro .sliders', {
    direction: 'horizontal',
    autoplay: false,
    cache: false,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
    },
    on: {
      init: function () {

      }
    }
  });
  
  if($('body').hasClass('template-product') || $('body').hasClass('template-packs')){
    var iid=$('#product-select').children("option:selected").data('iid');
    if(iid != undefined && iid != ""){
      var nid = $.trim(iid);
      var ind = $('.sliders').find('.swiper-slide').find('img[data-id="'+nid+'"]').closest('.swiper-slide:not(.swiper-slide-duplicate)').index();
      var ind2 = $.trim(ind);
      mainProductSlider_swiper.slideTo(ind2);
      mainProductSlider_swiper.update(true);
    }
  } 
});



$( document ).ready(function() {
  $('.header .header__inner .nav .menu>li a').on('click', function(){
    $(this).siblings('.dropdown_container').toggleClass('Open');
  });
  var newSwiper = new Swiper('.featured-product-slider-section .sliders', {
    direction: 'horizontal',
    autoplay: false,
    autoHeight: true,
    cache: false,
    loop: false,
    noSwiping: true,
    noSwipingClass: 'do_not_swipe',
    preloadImages: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    //    autoplay: {
    //      delay: 5000,
    //    },
    on: {
      init: function () {
        $('.featured-product-slider-section .slider').css('opacity','1');
        $('.featured-product-slider-section .slider-wrapper').each(function(){
          $(this).find('.all_specs_button').addClass('do_not_swipe');
        })
      },
      slideChange: function(){
        setTimeout(function(){
          //           alert('2');
          $('.featured-product-slider-section .sliders').find(".slider-wrapper").each(function(){
            var th = $(this);
            if(th.find('.all_specs_button').hasClass('full_link')){
              th.find('.text').removeClass('full_div');
              th.find('.right').removeClass('full_div');

              th.find('.text li').eq(2).nextAll().slideUp(200);
              th.find('.all_specs_button').removeClass('full_link');
              th.find('.all_specs_button').text('SHOW MORE FEATURES');
            }
          });
        },50);
      },
      sliderMove: function(){
        setTimeout(function(){
//           alert('2');
          $('.featured-product-slider-section .sliders').find(".slider-wrapper").each(function(){
            var th = $(this);
            if(th.find('.all_specs_button').hasClass('full_link')){
              th.find('.text').removeClass('full_div');
              th.find('.right').removeClass('full_div');

              th.find('.text li').eq(2).nextAll().slideUp(200);
              th.find('.all_specs_button').removeClass('full_link');
              th.find('.all_specs_button').text('SHOW MORE FEATURES');
            }
          });
        },50);
      }
    }
  });
//   newSwiper.slideTo(2);
//   setTimeout(function () {
//     newSwiper.slideTo(1);
//   }, 2000);
  var newSwiper1 = new Swiper('.testimonial-section .sliders', {
  direction: 'horizontal',
    autoplay: false,
    cache: false,
    loop: true,
    preloadImages: false,
    slidesPerView: 3,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 46,
      }
    },
    //    autoplay: {
    //      delay: 5000,
    //    },
    on: {
      init: function () {
        $('.testimonial-section .slider').css('opacity','1');
      }
    }
  });

/*// Pack Family Sldier : Desktop  
  if($(".product-family-section .desktop-cont .product-wrapper").length <= 4) {
    $('.product-family-section .desktop-cont .sliders').addClass("disabled");
    $('.product-family-section .desktop-cont .sliders').css('opacity','1');
    $('.product-family-section .desktop-cont .swiper-wrapper').addClass("disabled");
    $('.product-family-section .desktop-cont .swiper-pagination').addClass("disabled");
  }
  else{
    var newSwiper3 = new Swiper('.product-family-section .desktop-cont .sliders', {
      direction: 'horizontal',
      autoplay: false,
      cache: false,
      loop: false,
      preloadImages: false,
      noSwiping: true,
      noSwipingClass: 'do_not_swipe',
      slidesPerView : 4,
      spaceBetween: 36,
      mousewheel: {
        forceToAxis: true
      },
      freeMode: {
        enabled: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true
      },
      // pagination: {
      //   el: '.product-family-section .desktop-cont .swiper-pagination',
      //   clickable: true
      // },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      // navigation: {
      //   nextEl: '.product-family-section .desktop-cont .swiper-button-next',
      //   prevEl: '.product-family-section .desktop-cont .swiper-button-prev',
      // },
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        580: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        835: {
          slidesPerView: 2.2,
          spaceBetween: 28,
        },
        1025: {
          slidesPerView: 3.2,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 35,
        },
        1590: {
          slidesPerView: 4.5,
          spaceBetween: 36,
        }
      },
      //    autoplay: {
      //      delay: 5000,
      //    },
      on: {
        init: function () {
          $('.product-family-section .desktop-cont .sliders').css('opacity','1');
          $('.product-family-section .desktop-cont .product-wrapper').each(function(){
            $(this).find('.toggle-btn').addClass('do_not_swipe');
            $(this).find('.swatch').addClass('do_not_swipe');
          })
        }
      }
    });
  }
  
  // Pack Family Sldier : Mobile 
  if($(".product-family-section .desktop-cont .product-wrapper").length <= 3 ) {
    var newSwiper33 = new Swiper('.product-family-section .mobile-cont .sliders', {
      direction: 'horizontal',
      autoplay: false,
      cache: false,
      loop: false,
      preloadImages: false,
      noSwiping: true,
      noSwipingClass: 'do_not_swipe',
      slidesPerView : 4,
      spaceBetween: 36,
      mousewheel: {
        forceToAxis: true
      },
      freeMode: {
          enabled: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
      // pagination: {
      //   el: '.product-family-section .mobile-cont .swiper-pagination',
      //   clickable: true
      // },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      // navigation: {
      //   nextEl: '.product-family-section .mobile-cont .swiper-button-next',
      //   prevEl: '.product-family-section .mobile-cont .swiper-button-prev',
      // },
      breakpoints: {
       320: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        580: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        835: {
          slidesPerView: 2.2,
          spaceBetween: 28,
        },
        1025: {
          slidesPerView: 3.2,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 35,
        },
        1590: {
          slidesPerView: 4.5,
          spaceBetween: 36,
        }
      },
      //    autoplay: {
      //      delay: 5000,
      //    },
      on: {
        init: function () {
          $('.product-family-section .mobile-cont .sliders').css('opacity','1');
          $('.product-family-section .mobile-cont .product-wrapper').each(function(){
            $(this).find('.toggle-btn').addClass('do_not_swipe');
            $(this).find('.swatch').addClass('do_not_swipe');
          })
        }
      }
    });
  }
  else{
    var newSwiper33 = new Swiper('.product-family-section .mobile-cont .sliders', {
      direction: 'horizontal',
      autoplay: false,
      cache: false,
      loop: false,
      preloadImages: false,
      noSwiping: true,
      noSwipingClass: 'do_not_swipe',
      slidesPerView : 4,
      spaceBetween: 30,
      mousewheel: {
        forceToAxis: true
      },
      freeMode: {
          enabled: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
      // pagination: {
      //   el: '.product-family-section .mobile-cont .swiper-pagination',
      //   clickable: true
      // },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      // navigation: {
      //   nextEl: '.product-family-section .mobile-cont .swiper-button-next',
      //   prevEl: '.product-family-section .mobile-cont .swiper-button-prev',
      // },
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        580: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        835: {
          slidesPerView: 2.2,
          spaceBetween: 28,
        },
        1025: {
          slidesPerView: 3.2,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 35,
        },
        1590: {
          slidesPerView: 4.5,
          spaceBetween: 36,
        }
      },
      //    autoplay: {
      //      delay: 5000,
      //    },
      on: {
        init: function () {
          $('.product-family-section .mobile-cont .sliders').css('opacity','1');
          $('.product-family-section .mobile-cont .product-wrapper').each(function(){
            $(this).find('.toggle-btn').addClass('do_not_swipe');
            $(this).find('.swatch').addClass('do_not_swipe');
          })
        }
      }
    });
  }*/


  document.querySelectorAll('.product-family-section').forEach(section => {
    let products = parseInt(section.dataset.products);
    function mobileInit(){
      section.querySelector('.mobile-cont .sliders').style.opacity = 1;
      // section.querySelectorAll('.mobile-cont .product-wrapper').forEach(ele => {
      //   ele.querySelector('.toggle-btn').classList.add('do_not_swipe');
      //   ele.querySelector('.swatch').classList.add('do_not_swipe');
      // });
    } 
    function desktopInit(){
      section.querySelector('.desktop-cont .sliders').style.opacity = 1;
      // section.querySelectorAll('.desktop-cont .product-wrapper').forEach(ele => {
      //   ele.querySelector('.toggle-btn').classList.add('do_not_swipe');
      //   ele.querySelector('.swatch').classList.add('do_not_swipe');
      // });
    } 
    // Pack Family Sldier : Desktop  
    if(products <= 4){
      section.querySelector('.desktop-cont .sliders').classList.add('disabled');
      section.querySelector('.desktop-cont .sliders').style.opacity = 1;
      section.querySelector('.desktop-cont .swiper-wrapper').classList.add('disabled');
      // section.querySelector('.desktop-cont .swiper-pagination').classList.add('disabled');
    }else{
      var newSwiper3 = new Swiper(section.querySelector('.desktop-cont .sliders'), {
        direction: 'horizontal',
        autoplay: false,
        cache: false,
        loop: false,
        preloadImages: false,
        noSwiping: true,
        noSwipingClass: 'do_not_swipe',
        slidesPerView : 4,
        spaceBetween: 36,
        mousewheel: {
          forceToAxis: true
        },
        freeMode: {
          enabled: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          580: {
            slidesPerView: 2,
            spaceBetween: 25,
          },
          835: {
            slidesPerView: 2.2,
            spaceBetween: 28,
          },
          1025: {
            slidesPerView: 3.2,
            spaceBetween: 32,
          },
          1200: {
            slidesPerView: 3.5,
            spaceBetween: 35,
          },
          1590: {
            slidesPerView: 4.5,
            spaceBetween: 36,
          }
        },
        on: {
          init: desktopInit
        }
      });
    }

    // Pack Family Sldier : Mobile 
    var newSwiper33 = new Swiper(section.querySelector('.mobile-cont .sliders'), {
      direction: 'horizontal',
      autoplay: false,
      cache: false,
      loop: false,
      preloadImages: false,
      noSwiping: true,
      noSwipingClass: 'do_not_swipe',
      slidesPerView : 4,
      spaceBetween: (products <= 3) ? 36 : 30,
      mousewheel: {
        forceToAxis: true
      },
      freeMode: {
          enabled: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      breakpoints: {
       320: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        580: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        835: {
          slidesPerView: 2.2,
          spaceBetween: 28,
        },
        1025: {
          slidesPerView: 3.2,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 35,
        },
        1590: {
          slidesPerView: 4.5,
          spaceBetween: 36,
        }
      },
      on: {
        init: mobileInit
      }
    });
  });
  
//article single page slider for mobile

  var articleswiper = new Swiper('.article-swiper', {
      direction: 'horizontal',
      autoplay: false,
      cache: false,
      loop: false,
      preloadImages: false,
      noSwiping: true,
      slidesPerView : 4,
      spaceBetween: 40,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        580: {
          slidesPerView: 2.5,
      spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        }
      },
      
    });
   
  
  var newSwiper4 = new Swiper('.image-blocks-section .sliders', {
    direction: 'horizontal',
    autoplay: false,
    // cache: false,
    // autoHeight: true,
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    //    autoplay: {
    //      delay: 5000,
    //    },
    on: {
      init: function () {
        $('.image-blocks-section .slider').css('opacity','1');
      }
    }
  });
   
  var newSwiper5 = new Swiper('.ultra-image-with-text .page-slider', {
    direction: 'horizontal',
    autoplay: false,
    cache: false,
    loop: true,
    slidesPerView: 1,
    allowTouchMove: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        $('.ultra-image-with-text .page-slider').css('opacity','1');
      }
    }
  });
});

// window load
$(window).on('load', function(){

  function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
  
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
  };
  
  if(location.search.substring(1).indexOf('variant') != -1){
    var vid = getUrlParameter('variant');
    if($('#product-select').find('option[value="'+vid+'"]').length == 0){
      $('#AddToCartForm').find('input[type="radio"]').prop('checked', false);
      $('#addtocartbtn').prop('disabled', true);
      $('#addtocartbtn').val('Make a selection');
    }
  }
  
  if($('#product-select').find("option").length == 1){
    $('#product-select').find("option").prop('selected', true);
  }
  if(window.location.href.indexOf("variant") > -1){
    var url=window.location.href;
    /* var variant = url.split('variant=')[1]; */
    var variant = getUrlParameter('variant');

    if($('#AddToCartForm #product-select').length) {
      $('#AddToCartForm #product-select').val(variant).trigger('change');
      if($('#AddToCartForm #product-select').val()){

        var val1 = $('#AddToCartForm #product-select').find(':selected').attr('data-option-1');
        $('#AddToCartForm .swatch-wrapper').find('input[type="radio"][value='+ val1 +']').prop('checked', true).trigger('click');
        $('#AddToCartForm .swatch-wrapper').find('input[type="radio"][value='+ val1 +']').prop('checked', true).trigger('change');

        var val2 = $('#product-select').find(':selected').attr('data-option-2');
        $('#AddToCartForm .swatch-wrapper').find('input[type="radio"][value='+ val2 +']').prop('checked', true).trigger('click');
        $('#AddToCartForm .swatch-wrapper').find('input[type="radio"][value='+ val2 +']').prop('checked', true).trigger('change');

        var val3 = $('#product-select').find(':selected').attr('data-option-3');
        $('#AddToCartForm .swatch-wrapper').find('input[type="radio"][value='+ val3 +']').prop('checked', true).trigger('click');
        $('#AddToCartForm .swatch-wrapper').find('input[type="radio"][value='+ val3 +']').prop('checked', true).trigger('change');

        if($('#AddToCartForm #addtocartbtn').data('preorder') == true){
          $('#AddToCartForm #addtocartbtn').prop('disabled',false).val('Pre-Order');
        }else{
          $('#AddToCartForm #addtocartbtn').prop('disabled',false).val('add to cart');
        }
      }
    }
  }
  if($('body').hasClass('product-temp')){
    var avail = $('#AddToCartForm #product-select').find(':selected').attr('data-availability');
    if(avail){
      if($('#AddToCartForm #addtocartbtn').data('preorder') == true){
        $('#addtocartbtn').attr('disabled', false).val('Pre-Order');
      }else{
        $('#addtocartbtn').attr('disabled', false).val('add to cart');
      }
    }
  }
  if($(".featured-product-slider-section .sliders.desktop .slider-wrapper").length == 1) {
    $('.featured-product-slider-section .sliders.desktop .swiper-wrapper').addClass( "disabled" );
    $('.featured-product-slider-section .sliders.desktop .swiper-pagination').addClass( "disabled" );
    $('.featured-product-slider-section .sliders.desktop .swiper-button-next').addClass( "disabled" );
    $('.featured-product-slider-section .sliders.desktop .swiper-button-prev').addClass( "disabled" );
  }
  if($(".featured-product-slider-section .sliders.mobile .slider-wrapper").length == 1) {
    $('.featured-product-slider-section .sliders.mobile .swiper-wrapper').addClass( "disabled" );
    $('.featured-product-slider-section .sliders.mobile .swiper-pagination').addClass( "disabled" );
    $('.featured-product-slider-section .sliders.mobile .swiper-button-next').addClass( "disabled" );
    $('.featured-product-slider-section .sliders.mobile .swiper-button-prev').addClass( "disabled" );
  }
  
});

// filter options grid set
let interval = null

let domWorks = () => {

     let d = document.querySelector('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper')
     if(d){
      if($('.boost-pfs-filter-tree-h .boost-pfs-filter-option').length == 1 ) {
        $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').addClass('one-grid');
      }
      else if ($('.boost-pfs-filter-tree-h .boost-pfs-filter-option').length == 2 ) {
        $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').addClass('two-grid');
      }
       else{
        $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').removeClass('one-grid');
        $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').removeClass('two-grid');
      }

      $(document).on('click','.boost-pfs-filter-clear-all,.boost-pfs-filter-apply-button,.boost-pfs-filter-clear',function(){ 
         setTimeout(function() {
        if($('.boost-pfs-filter-tree-h .boost-pfs-filter-option').length == 1 ) {
         $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').addClass('one-grid');
      }
      else if ($('.boost-pfs-filter-tree-h .boost-pfs-filter-option').length == 2 ) {
        $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').addClass('two-grid');
      }
      else{
        $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').removeClass('one-grid');
        $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').removeClass('two-grid');
      }
    },800);
  });


      clearInterval(interval) // Change it via reference
     }
}
interval = setInterval(domWorks, 100)


// let c_interval = null

// let c_domWorks = () => {

//      let cd = document.querySelector('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper')
//      if(cd){
//       $(document).on('click','.boost-pfs-filter-clear-all',function(){ 

//       console.log('test', $('.boost-pfs-filter-tree-h .boost-pfs-filter-option').length);
//       if($('.boost-pfs-filter-tree-h .boost-pfs-filter-option').length == 1 ) {
     
//  $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').addClass('one-grid');

//       }
//       else if ($('.boost-pfs-filter-tree-h .boost-pfs-filter-option').length == 2 ) {

//         $('.boost-pfs-filter-tree-h .boost-pfs-filter-options-wrapper').addClass('two-grid');

//       }
//     });

//       clearInterval(c_interval) // Change it via reference
//      }
// }
// c_interval = setInterval(c_domWorks, 100)


// search bar custom edit
$(document).on('click','.search__btn_header',function(e){
  e.preventDefault();
  $('#search').addClass('active');
  setTimeout(function (){
    $('#search .boost-pfs-search-box').trigger("focus");
  },100);
});


$(window).click(function() {
  var searchActive = $('#search').hasClass('active');
  if(searchActive){
    $(this).removeClass('active');
  }
});


  if($('.boost-pfs-search-result-header:contains("General")').length > 0) {
    $(this).addClass("no-font");
  } 



Fancybox.bind("[data-fancybox]", {
  infinite: false,
  Thumbs:false,
  Toolbar:false
});
